import axios from 'axios';

const getObtenerProductoCancelar = async function(url, token) {
    try {
        return await axios({
            url,
            method: 'GET',
            params:{
                token: token,
            }
        })
    } catch (e) {
        return e.response
    }
}
export {
    getObtenerProductoCancelar
}